module.exports = __webpack_public_path__ + "media/images/animations/wide_loads/2-b9cc6342bdd5053646604a4ff648f805.png";